var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',{staticClass:"mb-3"},[_c('CCardHeader',[_vm._v("Rendimiento por dia")]),_c('CCardBody',[_c('apexchart',{attrs:{"type":"bar","height":"300","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }